import * as api from './middleware/api.middleware';
import { getAuthHeader } from "./auth/authHeaders";

const serviceUrl = "environments";
const getAccessToken = () => getAuthHeader();

export function getDataPlatformTargetType() {
    const getResponse = process.env.REACT_APP_API_URL === "http://localhost:3000/" ?
        api.get<any>(`data/${serviceUrl}/environment_types.json`) :
        api.get<any>(`${serviceUrl}/data_platform_types?is_on_prem=${false}`,getAccessToken())
    return getResponse;
}
export function getOnPremisesDataPlatformTypes() {
    const getResponse = process.env.REACT_APP_API_URL === "http://localhost:3000/" ?
        api.get<any>(`data/${serviceUrl}/environment_types.json`) :
        api.get<any>(`${serviceUrl}/data_platform_types?is_on_prem=${true}`,getAccessToken())
    return getResponse;
}
export function getEnvironmentsDetails() {
    const getResponse = process.env.REACT_APP_API_URL === "http://localhost:3000/" ?
        api.get<any>(`data/${serviceUrl}/environment_types.json`) :
        api.get<any>(`${serviceUrl}/environment_types`,getAccessToken())
    return getResponse;
}
export function getDataSources(Id:number, showInternalRegistered?: boolean) {
    const query =
        typeof showInternalRegistered === "boolean"
            ? `?show_internal_registered=${showInternalRegistered}`
            : "";
    const getResponse = process.env.REACT_APP_API_URL === "http://localhost:3000/" ?
        api.get<any>(`data/${serviceUrl}/data_platform_types.json`) :
        api.get<any>(`${serviceUrl}/${Id}/data_sources${query}`,getAccessToken())
    return getResponse;
}
export function getSourceEntityColumns(environmentId: number, dataSourceId: number, sourceEntityId: number) {
    const getResponse = process.env.REACT_APP_API_URL === "http://localhost:3000/" ?
        api.get<any>(`data/${serviceUrl}/data_platform_types.json`) :
        api.get<any>(`${serviceUrl}/${environmentId}/data_sources/${dataSourceId}/source_entity/${sourceEntityId}/source_entity_column`, getAccessToken());
    return getResponse;
}

export type SourceEntityColumnSyncStatusColumn = {
    source_entity_column_id?: number | null;
    source_entity_column_name: string;
    data_type?: string | null;
    status: string;
    message?: string | null;
    master_source_entity_column_id?: number | null;
    master_data_type?: string | null;
    missing_environment_ids?: number[];
    id_drift_environment_ids?: number[];
    type_mismatch_environment_ids?: number[];
};

export type SourceEntityColumnSyncStatusResponse = {
    source_environment_id: number;
    master_environment_id?: number | null;
    data_source_id: number;
    source_entity_id: number;
    data_source_exists_in_master: boolean;
    source_entity_exists_in_master: boolean;
    can_save_to_master: boolean;
    message?: string | null;
    master_source_entity_id?: number | null;
    master_candidate_source_entity_id?: number | null;
    counts: {
        total: number;
        synced: number;
        missing_in_master: number;
        source_entity_missing_in_master: number;
        id_drift: number;
        type_mismatch: number;
        not_mirrored: number;
        master_only: number;
    };
    columns: SourceEntityColumnSyncStatusColumn[];
    master_only_columns?: SourceEntityColumnSyncStatusColumn[];
};

export function getSourceEntityColumnSyncStatus(environmentId: number, dataSourceId: number, sourceEntityId: number) {
    const getResponse = process.env.REACT_APP_API_URL === "http://localhost:3000/" ?
        api.get<any>(`data/${serviceUrl}/data_platform_types.json`) :
        api.get<SourceEntityColumnSyncStatusResponse>(
            `${serviceUrl}/${environmentId}/data_sources/${dataSourceId}/source_entity/${sourceEntityId}/source_entity_column/sync-status`,
            getAccessToken()
        );
    return getResponse;
}

export type ManualSourceEntityColumnPayload = {
    columns: Array<{
        source_entity_column_name: string;
        data_type?: string | null;
        is_obsolete?: boolean;
        source_entity_column_details?: {
            logical_name?: string | null;
            description?: string | null;
            constraint?: string | null;
            data_format?: string | null;
            example_values?: string | null;
            enable_genai?: boolean;
            pii?: boolean;
            classification?: string | null;
            owner?: string | null;
            notes?: string | null;
        } | null;
    }>;
    mirror_environment_ids?: number[];
};

export function manualUpsertSourceEntityColumns(
    environmentId: number,
    dataSourceId: number,
    sourceEntityId: number,
    payload: ManualSourceEntityColumnPayload
) {
    const getResponse = process.env.REACT_APP_API_URL === "http://localhost:3000/" ?
        api.get<any>(`data/${serviceUrl}/data_platform_types.json`) :
        api.post<any>(
            `${serviceUrl}/${environmentId}/data_sources/${dataSourceId}/source_entity/${sourceEntityId}/source_entity_column/manual`,
            payload,
            getAccessToken()
        );
    return getResponse;
}
export function getDataSourcesForEnvironments(Id:number) {
    const getResponse = process.env.REACT_APP_API_URL === "http://localhost:3000/" ?
        api.get<any>(`data/${serviceUrl}/data_platform_types.json`) :
        api.get<any>(`${serviceUrl}/${Id}/data_sources/${2}`,getAccessToken())
    return getResponse;
}
export function getEnvironmentSetupFiles(Id:number,environment_id:number) {
    const getResponse = process.env.REACT_APP_API_URL === "http://localhost:3000/" ?
        api.get<any>(`data/${serviceUrl}/data_platform_types.json`) :
        api.get<any>(`customers/${Id}/${serviceUrl}/${environment_id}/environment_setup_files`,getAccessToken())
    return getResponse;
}
export function updateEnvironmentsDetails(data:any,customer_id:number,environment_id:number) {
    const getResponse = process.env.REACT_APP_API_URL === "http://localhost:3000/" ?
        api.get<any>(`data/${serviceUrl}/environment_types.json`) :
        api.put<any>(`customers/${customer_id}/${serviceUrl}/${environment_id}`,data,getAccessToken())
    return getResponse;
}
